import { Rive } from '@rive-app/webgl2';

export default function initHeaderHome(): void {
    const $headerhomeContainer = document.querySelectorAll('.block-header-home');

    $headerhomeContainer.forEach($container => {
        new HeaderHome($container as HTMLElement);
    });
}

class HeaderHome {
    $el: HTMLElement;
    rive: Rive | null = null;

    constructor($el: HTMLElement) {
        this.$el = $el;
        this.init();
    }

    init(): void {
        const riveCanvas = this.$el.querySelector(".rive-animation") as HTMLCanvasElement;
        const src = riveCanvas?.getAttribute('data-src');

        if (src && riveCanvas) {
            const riveInstance = new Rive({
                src: src,
                canvas: riveCanvas,
                autoplay: true,
                artboard: "Artboard",
                stateMachines: "State Machine 1",
                automaticallyHandleEvents: true,
                onLoad: () => {
                    riveInstance.resizeDrawingSurfaceToCanvas();
                    this.setupMouseTracking(riveCanvas, riveInstance);
                }
            });

            this.rive = riveInstance;
        }
    }

    setupMouseTracking(canvas: HTMLCanvasElement, riveInstance: Rive): void {
        let rect = canvas.getBoundingClientRect();

        // Accès non typé au artboard
        const artboard: any = (riveInstance as any).artboard;
        const mouseTarget = artboard.node("Mouse_Target");

        if (!mouseTarget) {
            return;
        }

        // Événement souris global
        document.addEventListener("mousemove", (event: MouseEvent) => {
            rect = canvas.getBoundingClientRect();
            const x = ((event.clientX - rect.left) * 500) / rect.width;
            const y = ((event.clientY - rect.top) * 500) / rect.height;

            mouseTarget.x = x;
            mouseTarget.y = y;
        });

        // Resize responsive
        const computeSize = () => {
            riveInstance.resizeDrawingSurfaceToCanvas();
        };

        window.addEventListener("resize", computeSize);
        window.matchMedia(`(resolution: ${window.devicePixelRatio}dppx)`)
            .addEventListener("change", computeSize);
    }
}
